import { FC } from "react";

interface IconProps {
  color?: string;
}

const Activity: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 22 22" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="m6.641 13.55 2.744-3.566 3.13 2.458 2.684-3.465"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle
      cx="18.329"
      cy="3.85"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      r="1.762"
      fill="none"
    />
    <path
      d="M13.68 2.86H7.02c-2.76 0-4.472 1.955-4.472 4.716v7.408c0 2.76 1.678 4.708 4.472 4.708h7.887c2.76 0 4.472-1.947 4.472-4.708V8.532"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Activity;
